import React, {useRef} from "react";
import {FormattedMessage} from "react-intl";
import {closeModal, openModal} from "../utils/dialog";
import "../styles/Dialog.css";
import {ReactComponent as CallCourierIcon} from "../image/call-icon.svg";
import {ReactComponent as CallButtonIcon} from "../image/call-button-icon.svg";
import {readablePhoneNumber} from "../utils/readablePhoneNumber";

export interface DialogProps {
    phoneNumber: string;
    codeForCommunication?: string;
    ivrEnabled?: boolean;
    maskedNumber?: boolean;
    guestRide?: boolean;
}

export function CallCourierDialog({
    phoneNumber,
    codeForCommunication,
    ivrEnabled,
    maskedNumber,
    guestRide,
}: DialogProps) {
    const ref = useRef<HTMLDialogElement>(null);

    return (
        <>
            <button
                className="stop-action call-button"
                onClick={() => openModal(ref.current)}
                data-cy="tracking-call-driver-btn"
            >
                <CallCourierIcon />
                <FormattedMessage id="call" />
            </button>

            <dialog
                className="modal"
                ref={ref}
                onClick={(e) => {
                    e.currentTarget === e.target && closeModal(ref.current);
                }}
            >
                <div className="header">
                    <p id="title" className="title">
                        {ivrEnabled || !maskedNumber || !guestRide ? (
                            <FormattedMessage id="call_courier_dialog_title_ivr_enabled" />
                        ) : (
                            <FormattedMessage id="call_courier_dialog_title_ivr_disabled" />
                        )}
                    </p>
                    <button className="close-button" onClick={() => closeModal(ref.current)}>
                        ×
                    </button>
                </div>

                {maskedNumber && (
                    <p className="text">
                        <FormattedMessage id="call_courier_dialog_subtitle" />
                    </p>
                )}

                {ivrEnabled && codeForCommunication ? (
                    <div className="code-section">
                        <span className="code-label">
                            <FormattedMessage id="code_for_communication" />
                        </span>
                        <span className="code">{codeForCommunication}</span>
                    </div>
                ) : null}
                <a className="primary-button" href={"tel:" + phoneNumber}>
                    <CallButtonIcon />
                    {readablePhoneNumber(phoneNumber)}
                </a>
            </dialog>
        </>
    );
}
